import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-wrap gap-2 p-2" }
const _hoisted_2 = { class: "font-normal text-color-secondary pt-1" }

import { computed, toRefs } from 'vue';
import { useDateTime } from '@/composables';

interface Props {
  title: string;
  name: string;
  dates: Date | string[];
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ReportSubjectTitle',
  props: {
    title: { default: null },
    name: { default: '' },
    dates: { default: () => [] || '' }
  },
  setup(__props: any) {

const props = __props;

const { title, name, dates } = toRefs(props);

const subject: string = computed(() => `${title.value} Report for ${name.value}`);

const formattedDates: string = computed(() => {
  if (dates.value instanceof Array) {
    const start = useDateTime().formatDateShortMonth(dates.value[0]);
    const end = useDateTime().formatDateShortMonth(dates.value[1]);
    return dates.value.length > 0 ? `${start} to ${end}` : '';
  }

  return useDateTime().formatDateShortMonth(dates.value);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", null, _toDisplayString(subject.value), 1),
    _createElementVNode("p", _hoisted_2, _toDisplayString(formattedDates.value), 1)
  ]))
}
}

})